import React from 'react';
import { Carousel, CarouselProps } from '@/components/features/cms/blocks/Carousel/Carousel';
import { Carousel as DSCarousel } from '@/components/shared/Carousel';

export const CarouselWithOverrides: React.FC<CarouselProps> = (props) => {
	return <Carousel {...props} DSCarousel={DSCarousel} />;
};
